import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Container, { ContainerProps } from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

const PageContentHeader = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  gap: theme.spacing(2),
}));

const PageHeaderToolbar = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  gap: theme.spacing(1),
  marginLeft: "auto",
}));

export interface Breadcrumb {
  title: string;
  path?: string;
}
export interface PageContainerProps extends ContainerProps {
  children?: React.ReactNode;
  title?: string;
  actions?: React.ReactNode;
  maxHeight?: string;
}

const PageContainer = (props: PageContainerProps) => {
  const { children, title, actions = null, maxHeight = "785px" } = props;

  return (
    <Container
      maxWidth={false}
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        backgroundColor: (theme) => theme.palette.background.paper,
        pb: 3,
      }}
    >
      <Stack sx={{ flex: 1, my: 2, maxHeight, overflow: "auto" }} spacing={2}>
        <Stack>
          <PageContentHeader>
            {title ? (
              <Typography
                variant="h5"
                sx={{ fontWeight: 600, fontSize: 18, alignSelf: "center" }}
              >
                {title}
              </Typography>
            ) : null}
            <PageHeaderToolbar>{actions}</PageHeaderToolbar>
          </PageContentHeader>
        </Stack>
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
          {children}
        </Box>
      </Stack>
    </Container>
  );
};
export default PageContainer;
